/* eslint-disable react/button-has-type */
import { ButtonHTMLAttributes } from "react";

type Props = {
  theme: "light" | "dark" | "blue";
  size: "small" | "medium" | "large";
} & ButtonHTMLAttributes<HTMLButtonElement>;

const Button = ({ theme, size, children, className, ...props }: Props) => {
  const bgColor =
    theme === "dark"
      ? "bg-black"
      : theme === "light"
      ? "bg-white"
      : "bg-main-blue";
  const textColor = theme === "light" ? "text-black" : "text-white";
  const spacing =
    size === "large" ? "p-5" : size === "small" ? "p-2.5" : "p-3.5";
  const fontSize =
    size === "large" ? "text-3xl leading-3xl" : "text-sm leading-sm";

  return (
    <button
      {...props}
      className={`
      ${spacing}
      ${bgColor}
      ${textColor}
      ${fontSize}
      font-medium
      w-full 
      flex 
      justify-center 
      rounded-lg
      ${className}
      `}
      style={{ outline: "none" }}
    >
      {children}
    </button>
  );
};

export { Button };
